<script setup>
import instagram from '~/assets/images/author-socials/instagram.svg';
import telegram from '~/assets/images/author-socials/telegram.svg';
import twitter from '~/assets/images/author-socials/twitter.svg';
import website from '~/assets/images/author-socials/website.svg';

const icons = {
  instagram,
  telegram,
  twitter,
  website,
};

defineProps({
  socials: {
    type: Object,
    required: true,
  },
});
function getIconSource(key) {
  return icons[key];
}
</script>

<template>
  <ul class="author-socials">
    <li v-for="(value, key) in socials" :key="key" class="author-socials__item">
      <a :href="value" target="_blank">
        <img :src="getIconSource(key)" :alt="`${key}-icon`" />
      </a>
    </li>
  </ul>
</template>

<style lang="postcss" scoped>
.author-socials {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  &__item {
    transition: var(--default-transition) opacity;

    img {
      width: 48px;
      height: 48px;
    }

    &:hover {
      opacity: 0.6;
    }
  }

  @media (--small-vp) {
    gap: 12px;
  }
}
</style>
